// src/composables/useAadhaar.js
import { ref } from 'vue';
import aadhaarService from '@/services/aadharServices';

export function useAadhaar(axios) {
  const aadharId = ref('');
  const fullName = ref('');
  const firstName = ref('');
  const lastName = ref('');
  const aadharClientId = ref('');
  const aadhar_message = ref('');
  const message = ref('');
  const address = ref('');
  const otherdetails = ref('');
  const otp = ref('');
  const isLoading = ref(false);
  const error = ref(null);

  const generateOtp = async (kyc_no='') => {
    try {
      let otpSuccessMessage="OTP successfully sent to your Aadhaar registered Mobile Number";
      let aadharNotLinkedMessage="Aadhaar number not linked to Mobile number";
      let aadharErrorGeneratingMessage="Aadhaar-Error while generating OTP. Please try again";
      if(kyc_no!=''){
        aadharId.value=kyc_no;
      }
      isLoading.value = true;
      const response = await aadhaarService(axios).generateOtp(aadharId.value);
      // const response ={data:{
      //   data: {
      //       client_id: "aadhaar_v2_rCVObUoEpbHOUsmykmjr",
      //       otp_sent: true,
      //       if_number: true,
      //       valid_aadhaar: true,
      //       status: "generate_otp_success"
      //   },
      //   status_code: 200,
      //   message_code: "success",
      //   message: "OTP Sent.",
      //   success: true
      // }};
      // console.log(response.data.success);
      // if(response.data.success){
      //   console.log(response.data.client_id);
      // }
      aadharClientId.value = response.data.data.client_id;
      console.log(response.data);
      // aadhar_message.value = response.data.message;
      aadhar_message.value = otpSuccessMessage;
      if(response.data.data.status=="no_mobile_number_aadhaar"){
        aadhar_message.value = aadharNotLinkedMessage;
      }
      if(response.data.status_code==429){
        aadhar_message.value="Please Try Again";
      }
      if(response.data.status_code != 200 && response.data.status_code!=429){
        aadhar_message.value= aadharErrorGeneratingMessage;
      }
      console.log(response);
      return response.data;
    } catch (err) {
      error.value = err;
      message.value = err.response.data.message;
      aadhar_message.value = err.response.data.message;
      console.error('Error generating OTP:', err);
    } finally {
      isLoading.value = false;
    }
  };
  const resendOtp = async () => {
    try {
      isLoading.value = true;
      const response = await aadhaarService(axios).generateOtp(aadharId.value);
      // const response={data:{
      //   data: {
      //       client_id: "aadhaar_v2_rCVObUoEpbHOUsmykmjr",
      //       otp_sent: true,
      //       if_number: true,
      //       valid_aadhaar: true,
      //       status: "generate_otp_success"
      //   },
      //   status_code: 200,
      //   message_code: "success",
      //   message: "OTP Sent.",
      //   success: true
      // }};
      // console.log(response.data.success);
      // if(response.data.success){
      //   console.log(response.data.client_id);
      // }
      aadharClientId.value = response.data.data.client_id;
      console.log(response.data);
      // aadhar_message.value = response.data.message;
      aadhar_message.value = 'OTP successfully sent to your Aadhaar registered Mobile Number';
      console.log(response);
      return response.data;
    } catch (err) {
      error.value = err;
      message.value = err.response.data.message;
      aadhar_message.value = err.response.data.message;
      console.error('Error generating OTP:', err);
    } finally {
      isLoading.value = false;
    }
  };

  const submitOtp = async () => {
    try {
      isLoading.value = true;
      const response = await aadhaarService(axios).submitOtp(aadharClientId.value, otp.value);
      // const response={data:{
      //   data: {
      //       client_id: "aadhaar_v2_rCVObUoEpbHOUsmykmjr",
      //       full_name: "Vishal Singh Rathore",
      //       aadhaar_number: "1234567891234",
      //       dob: "1857-07-25",
      //       gender: "M",
      //       address: {
      //           country: "India",
      //           dist: "XYZ",
      //           state: "XYZ",
      //           po: "XYZ",
      //           loc: "XYZ",
      //           vtc: "XYZ",
      //           subdist: "XYZ",
      //           street: "XYZ",
      //           house: "XYZ",
      //           landmark: "XYZ"
      //       },
      //       face_status: false,
      //       face_score: -1,
      //       zip: "000000",
      //       profile_image: "/9j/4AAQSkZJRgABAgAAAQABAAD/2wBDAAgGBgcGBQgHBwcJCQgKDBQNDAsLDBkSEw8UHRofHh0aHBwgJC4nICIs",
      //       has_image: true,
      //       email_hash: "57856f904d16e86c0cd87256b5",
      //       mobile_hash: "a21cdfc6058437e79a454328",
      //       raw_xml: "http://aadhaar-kyc-docs.s3.ama551420231217131441607-2023-12-17-074441792607.xml?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credenti4d8dcca346a636ada0a460fb6fc1486820ade5c4bb799ff6b55d8cd6caa41f3a",
      //       zip_data: "http://t&X-Amz-Date=20231217T074441Z&X-Amz-Expires=432000&X-Amz-SignedHeaders=host&X-Amz-Signature=d6140e0b723bf151ab924feb45241eb4594ea6a27182685977f5214aafb14a50",
      //       care_of: "S/: XXX ",
      //       share_code: "9820",
      //       mobile_verified: false,
      //       reference_id: "1234567897897",
      //       aadhaar_pdf: null,
      //       status: "success_aadhaar",
      //       uniqueness_id: "5385fd86a30a3ab99aee07b9e5b086dffb31b82f5b3a3657d"
      //   },
      //   status_code: 200,
      //   success: true,
      //   message: null,
      //   message_code: "success"
      // }};
      console.log(response.data);
      console.log(response.data.data);
      // if(response.data.status_code == 200){
        address.value = response.data.data.address;
        otherdetails.value = response.data.data;
        fullName.value = otherdetails.value.full_name;
        const trimmedName = otherdetails.value.full_name.trim();
      const firstSpaceIndex = trimmedName.indexOf(' ');
      aadhar_message.value = response.data.message;

      if (firstSpaceIndex === -1) {
        firstName.value = trimmedName;
        lastName.value = "";
      } else {
        firstName.value = trimmedName.slice(0, firstSpaceIndex);
        lastName.value = trimmedName.slice(firstSpaceIndex + 1).trim();
      }
      // }
      return response.data;
    } catch (err) {
      error.value = err;
      aadhar_message.value = err.response.data.message;
      console.error('Error submitting OTP:', err);
      return err.response?.data;
    } finally {
      isLoading.value = false;
    }
  };
  const nameMatch = async(aadhar_number,name2)=>{
    try {
      isLoading.value = true;
      const response = await aadhaarService(axios).nameMatch(aadhar_number, name2);
      console.log(response.data);
      // console.log(response.data.data);
      return response.data;
    } catch (err) {
      error.value = err;
      console.error('Error Name Matching:', err);
    } finally {
      isLoading.value = false;
    }
  };
 
  return {
    address,
    otherdetails,
    aadharId,
    fullName,
    firstName,
    lastName, 
    message,
    aadharClientId,
    otp,
    aadhar_message,
    generateOtp,
    submitOtp,
    resendOtp,
    nameMatch,
    isLoading,
    error,
  };
}
